import { render, staticRenderFns } from "./customerModal.vue?vue&type=template&id=7bba61f6&"
import script from "./customerModal.vue?vue&type=script&lang=js&"
export * from "./customerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports